// src/modules/app-views/products/pages/Document/tabs/FiscalTab/index.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import SimpleLoadingArea from 'components/SimpleComponents/SimpleLoadingArea';
import { useDocumentContext } from 'components/core/DocumentProvider';

// Card Components
import FiscalDataCard from './FiscalDataCard';
import FiscalRatesCard from './FiscalRatesCard';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const ProductsFiscalTab = () => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const { data, loading } = useDocumentContext();

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. HOOKS & REFS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 4. LOCAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 5. EFFECTS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 6. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <div className="container" style={{ position: 'relative', minHeight: 120 }}>
      <SimpleLoadingArea name="productFiscal" isFetching={loading} data={data} />

      {/* FISCAL DATA CARD - NCM, CEST, CFOP, Origin */}
      <FiscalDataCard />

      {/* FISCAL RATES CARD - CST and Rates */}
      <FiscalRatesCard />
    </div>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default ProductsFiscalTab;
